import { logApplicationError } from "@j/core/global/functions";

const my_components = document.getElementsByClassName("form-builder-renderer");

for ( var i = 0; i < my_components.length; i ++ ) {
    window['form_builder_vue_instance'] = new Vue({
        el: `#${my_components[i].id}`
    });
}

window.logApplicationError = logApplicationError;